import React from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    Stack,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import bgimage from "../../img/no_image.png"; // adjust path if needed

const stripHtml = (html) =>
    typeof html === "string" ? html.replace(/<[^>]+>/g, "") : "";

const GigCard = ({ gig, onView, onEdit }) => {
    const {
        Title,
        BrandName,
        BrandLogoURL,
        DeadLineDate,
        RewardAmount,
        AboutGigWork,
        Requirements,
        SubTitle,
        Location,
        GigWorkType,
    } = gig || {};

    const logo = BrandLogoURL || BrandLogoURL === null ? BrandLogoURL : bgimage;

    const category = GigWorkType?.[0]?.TypeName;

    const rewardText = RewardAmount
        ? `₹${Number(RewardAmount).toLocaleString("en-IN")}`
        : "—";

    const description =
        SubTitle ||
        stripHtml(AboutGigWork) ||
        stripHtml(Requirements) ||
        "";

    return (
        <Card
            sx={{
                borderRadius: "16px",
                boxShadow: "0px 4px 10px rgba(0,0,0,0.06)",
                backgroundColor: "#FFFFFF",
                overflow: "hidden",
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <CardContent sx={{ p: 2.5, pb: 2, flexGrow: 1 }}>
                {/* Top: Logo + Title + Brand */}
                <Box display="flex" alignItems="center" gap={2} mb={1.5}>
                    {/* <Box
                        component="img"
                        src={logo || bgimage}
                        alt={BrandName || Title || "brand"}
                        sx={{
                            width: 64,
                            height: 64,
                            borderRadius: "8px",
                            objectFit: "contain",
                            backgroundColor: "#F5F5F5",
                        }}
                    /> */}
                    <Box flex={1}>
                        <Typography
                            variant="subtitle1"
                            sx={{ fontWeight: 600, fontSize: "16px", color: "#292929", lineHeight: 1.2 }}
                        >
                            {Title || "--"}
                        </Typography>
                        <Typography
                            variant="body2"
                            sx={{ color: "#7A7A7A", mt: 0.5, fontSize: '14px' }}
                        >
                            {BrandName || "--"}
                        </Typography>
                    </Box>
                </Box>

                {/* Date + Reward */}
                <Box
                    display="flex"
                    alignItems="center"
                    // justifyContent="space-between"
                    flexWrap="wrap"
                    gap={2}
                    mb={1.5}
                >
                    <Box display="flex" alignItems="center" gap={0.8}>
                        <CalendarMonthIcon sx={{ fontSize: 18, color: "#B8B8B8" }} />
                        <Typography variant="body2" sx={{ fontSize: '14px', color: "#7A7A7A" }}>
                            {DeadLineDate || "Deadline N/A"}
                        </Typography>
                    </Box>

                    <Box display="flex" alignItems="center" gap={0.8}>
                        <PeopleAltIcon sx={{ fontSize: 18, color: "#B8B8B8" }} />
                        <Typography variant="body2" sx={{ color: "#A6A6A6", fontWeight: 600 }}>
                            Rewards:&nbsp;
                            <span style={{ color: '#219653' }}>{rewardText}</span>
                        </Typography>
                    </Box>
                </Box>

                {/* Description */}
                {description && (
                    <Typography
                        variant="body2"
                        sx={{
                            color: "#757575",
                            mb: 2,
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                        }}
                    >
                        {description}
                    </Typography>
                )}
            </CardContent>

            {/* Actions */}
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="stretch"
                sx={{
                    px: 2,
                    pb: 2,
                    gap: 2,
                }}
            >
                {onEdit && (
                    <Button
                        fullWidth
                        variant="text"
                        onClick={onEdit}
                        sx={{
                            textTransform: "none",
                            fontWeight: 600,
                            // backgroundColor: "#F14950",
                            color: "#F14950",
                            boxShadow: "none",
                            px: 3,
                            border: "1px solid",
                            borderColor: "#F14950",
                            alignSelf: "flex-end",
                            "&:hover": {
                                // backgroundColor: "#b02a2a",
                                boxShadow: "none",
                            },
                        }}
                    >
                        Edit
                    </Button>
                )}
                {onView && (<Button
                    fullWidth
                    variant="contained"
                    onClick={onView}
                    sx={{
                        textTransform: "none",
                        fontWeight: 600,
                        backgroundColor: "#F14950",
                        color: "#fff",
                        boxShadow: "none",
                        px: 3,
                        alignSelf: "flex-end",
                        "&:hover": {
                            backgroundColor: "#b02a2a",
                            boxShadow: "none",
                        },
                    }}
                >
                    View
                </Button>)}


            </Stack>
        </Card>
    );
};

export default GigCard;
